import { getRoundedMembersCount } from "@qoohoo/common/utils/number";

const MemberCountDisplayLabel = ({ totalMembers }) => {
  let memberCountLabel = "";

  if (totalMembers > 0) {
    const roundedMembersCount = getRoundedMembersCount(totalMembers);
    const memberTextLabel = totalMembers === 1 ? "Member" : "Members";

    memberCountLabel = `${roundedMembersCount} ${memberTextLabel} `;
  } else {
    memberCountLabel = "";
  }

  return (
    <span className="ml-2 sm:ml-2.5 text-sm sm:text-base font-semibold font-nunito">
      {memberCountLabel}
    </span>
  );
};

export default MemberCountDisplayLabel;
